












import { Component, Prop, Watch } from 'vue-property-decorator'
import ViewBase from '@/util/ViewBase'
// import PlayList from './playList.vue'

@Component({
  components: {
    // PlayList
  }
})
export default class PlayLayout extends ViewBase {
}
